import { render, staticRenderFns } from "./retailer-details.vue?vue&type=template&id=4a64450e&scoped=true"
import script from "./retailer-details.vue?vue&type=script&lang=js"
export * from "./retailer-details.vue?vue&type=script&lang=js"
import style0 from "./retailer-details.vue?vue&type=style&index=0&id=4a64450e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a64450e",
  null
  
)

export default component.exports